<template>
    <div class="diagram">
        <Title firstName="接线图" lastName="WIRING DIAGRAM"/>
        <div class="echarts">
            <div class="selectMonitor" @click="tabName">
                <!-- {{currentName}} -->
                <i class="el-icon-arrow-down"></i>
            </div>
            <div id="iframeCon" v-if="currentName != ''">
                <iframe v-show="currentName != ''" width="100%" height="100%" :src="iframeSrc" frameborder="0"></iframe>
                <!-- 全屏按钮 -->
                <div id="fullscreenD"  >
                    <img :src="!isFull?fullSrc[0]:fullSrc[1]" alt="全屏" /><span v-show="isFull">取消全屏</span>
                </div>
                <div class="imgjxt" v-show="currentName == ''">
                    <img class="imgjz" src="@/assets/img/加载视频.png" alt="" />
                    <p>暂无接线图</p>
                </div>
            </div>
            <div class="list" v-show="isShow">
                <SelectList :selectList="selectList" @tabTitle="tabTitle" keyk="areaId" keyval="name"/>
            </div>
            
            <div class="bottom"></div>
        </div>
    </div>
</template>

<script>
import { GetDistribution } from '../../components/Request'
import screenfull from "screenfull"; // 引入全屏显示
const Title = () => import('../../components/title/Title')
const SelectList = () => import('../../components/title/selectList')
export default {
    data(){
        return {
            isFull:false,
            iframeSrc:'',
            fullSrc:[require('@/assets/img/escaIn.png'),require('@/assets/img/escaOut.png')],
            currentName: '大测试好',
            selectList:[
                {
                    id:1,
                    value:'接线图一'
                },
                {
                    id:2,
                    value:'接线图二'
                },
                {
                    id:3,
                    value:'接线图三'
                },
            ],
            isShow:false,
        }
    },
    watch: {
    },
    components:{
        Title,SelectList
    },
    mounted(){
        this.fullscreen()
        this.getProjectDiagram()
    },
    methods:{
        // 全屏显示 
        fullscreen(){
            const element = document.getElementById('iframeCon');
            document.getElementById('fullscreenD').addEventListener('click', () => {
                this.isFull = !this.isFull
                if(this.isFull){
                    screenfull.request(element); // 元素全屏
                }else{
                    screenfull.toggle(); // 元素全屏
                }
            });
        },
        tabTitle(title){
            this.currentName = title.name
            this.isShow = false
            this.iframeSrc = title.url

        },
        tabName(){
            this.isShow = !this.isShow 
        },
        // 获取当前项目所有接线图
        async getProjectDiagram(){
            let data = {
                projectId:this.$store.state.projectId
            }
            let res = await GetDistribution(data)
            console.log(res);
            this.selectList = res.data.data.result
            this.currentName = res.data.data.result[0].name
            this.iframeSrc = res.data.data.result[0].url
        }
    }
}
</script>

<style lang="less" scoped>
    .diagram{
        height: 33.3vh;
        width: 20vw;
        position: fixed;
        top: 7.4vh;
        right: 1vw;

        .echarts{
            position: relative;
            height: 25vh;
            padding-bottom: 1vh;
            background:  linear-gradient(0deg, rgba(0, 33, 59, 0.6) 0%, rgba(3, 13, 24, 0.7) 100%);
            .selectMonitor{
                height: 3vh;
                line-height: 3vh;
                text-align: right;
                margin-right: 0.5vw;
                color: #E6F3FD ;
                cursor: pointer;
            }

            #iframeCon{
                height: 21vh;
                background-color: #000;
                position: relative;
                text-align: center;
                
                &>.imgjxt{
                    font-size: 14rem;
                    color: #fff;
                    position: absolute;
                    left:50% ;
                    top: 50%;
                    transform: translate(-50%, -50%);
                    .imgjz{
                        width: 3.5vw;
                    }
                }
                #fullscreenD{
                    position: absolute;
                    right:0.5vw ;
                    bottom: 1vh;
                    cursor: pointer;
                    &>img{
                        width: 2.5vh;
                        height: 2.5vh;
                        vertical-align: middle;

                    }
                    span{
                        color: #000;
                        vertical-align: middle;
                        font-size: 20rem;
                        margin-left: 10rem;
                    }
                }
            }
            
            .list{
                height: 10.5vh;
                width: 100%;
                position: absolute;
                left: 0;
                top: 3vh;
                z-index: 11;
            }

            .bottom{
                width: 20vw;
                height: 1vh;
                background: url(../../assets/img/板块装饰线.png) no-repeat;
                block-size: 100% 100%;
                position: absolute;
                bottom: 0;
                left: 0;
            }
        }

        
    }

</style>